/**
 * The data explorer's debug reads: the Durable Object types they inspect and their `limit`
 * bounds, which the admin contract's request schemas validate and every class's debug read
 * (`debug-read.ts`, `debug-redaction.ts` in the backend) applies again. Declared apart from the
 * admin contract, which imports them, so every Durable Object class loads them without that
 * contract's schemas (gh #5083, decision 61; `scripts/check-backend-startup-graph.ts`). The
 * contracts barrel exports them.
 */

import { z } from 'zod';

/** Valid DO types for debug reads. Shared source of truth — re-exported as `DoType` in debug-redaction.ts. */
export const dataExplorerDebugDoType = z.enum(['hub', 'org', 'conversation', 'user', 'platform', 'thread', 'community', 'contact_book', 'batch']);

export type DataExplorerDebugDoType = z.infer<typeof dataExplorerDebugDoType>;

/** Hard cap on `limit` query param — applied in both Zod and the DO RPC. */
export const DEBUG_READ_MAX_LIMIT = 100;
/** Default `limit` when the caller omits it. */
export const DEBUG_READ_DEFAULT_LIMIT = 20;
